import { Currency, type OpenExchangeCurrency } from '../types';
import { getCurrencySymbol } from '../constants/currency-symbol';

export function getFormattedBalance(
    balance: number | string | undefined,
    currency?: OpenExchangeCurrency | Currency,
    zero?: number
) {
    const symbol = getCurrencySymbol(currency ?? Currency.Usd) ?? '$';
    const numeric = Number.isInteger(balance) ? (balance as number) / 100 : Number(balance);
    const abs = Math.abs(numeric);
    const defaultZero = Number.isInteger(balance) && (balance as number) % 100 === 0 ? 0 : 2;
    if (abs) {
        return `${numeric < 0 ? '-' : ''} ${symbol}${abs.toFixed(zero ?? defaultZero)}`;
    }

    return `${symbol}0.${zero ? '0'.repeat(zero) : '00'}`;
}

export function formatFraction(balance: number | undefined) {
    if (!balance) {
        return 0;
    }

    return balance.toFixed(Math.abs(balance) % 100 === 0 ? 0 : 2)
}

export function getFormattedBalanceValue(balance: number | undefined) {
    if (balance) {
        return balance / 100;
    }

    return 0;
}
